<script lang="ts" setup></script>

<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Frame 1597880653">
      <g id="H">
        <g id="Vector">
          <path
              d="M12.0474 9.20456C11.5916 9.20456 11.0705 9.55722 10.8841 9.99197L9.15823 14.008C8.97178 14.4428 9.1901 14.7954 9.64586 14.7954H11.9549C12.4107 14.7954 12.9318 14.4428 13.1182 14.008L14.8425 9.99197C15.0289 9.55722 14.8106 9.20456 14.3549 9.20456H12.0474Z"
              fill="#F40000"
          />
          <path
              d="M21.4462 5H19.1212C18.6655 5 18.1428 5.35266 17.9563 5.78741L13.0736 17.0999C12.6179 18.1488 11.7111 19 11.7111 19H15.4066C15.8624 19 16.3851 18.6473 16.5715 18.2126L21.9323 5.78892C22.1203 5.35266 21.9036 5 21.4462 5Z"
              fill="#F40000"
          />
          <path
              d="M2.55289 19H4.87791C5.33367 19 5.85636 18.6473 6.04281 18.2126L10.9255 6.90011C11.3813 5.85125 12.288 5.00152 12.288 5.00152H8.59251C8.13675 5.00152 7.61406 5.35418 7.42761 5.78892L2.06685 18.2126C1.88041 18.6473 2.09713 19 2.55289 19Z"
              fill="#F40000"
          />
        </g>
      </g>
    </g>
  </svg>
</template>